module.exports = __webpack_public_path__ + "assets/img/banner-15.305cbe9f.jpg";